(function () {
  if (window.customCartNewsletterBannerInitialized) return;
  window.customCartNewsletterBannerInitialized = true;

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-custom-cart-newsletter-link]');
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href || href.charAt(0) !== '#') return;

    var target = document.getElementById(href.slice(1));
    if (!target) return;

    event.preventDefault();

    var cartDrawer = link.closest('hdt-cart-drawer');
    var closeDrawer = cartDrawer && typeof cartDrawer.close === 'function'
      ? cartDrawer.close()
      : Promise.resolve();

    Promise.resolve(closeDrawer).then(function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });

      window.setTimeout(function () {
        var emailInput = target.querySelector('input[type="email"]')
          || target.parentElement.querySelector('input[type="email"]');
        if (emailInput) emailInput.focus({ preventScroll: true });
      }, 450);
    });
  });
})();
